import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

export const AbandonedCart = {
  Content: lazy(
    () =>
      import(
        'components/abandoned-cart/components/AbandonedCart/AbandonedCartContent'
      )
  )
};

export default AbandonedCart;
